var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "typeform-popin" }, [
      _c("iframe", {
        attrs: {
          width: "100%",
          height: "100%",
          src: "https://verspieren.typeform.com/to/P0QMhb?source=feedbackbutton",
          frameborder: "0",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }